// MUI Components
import { Box } from "@mui/material";

// Custom Components
import MDBox from "components/MDBox";

// Assets
import bgIm from "assets/images/t2CCNu53AN.gif";

// Wind turbine loader shown inside a table body while its data is loading
export default function TableLoader() {
  return (
    <MDBox py={5} display="flex" justifyContent="center" alignItems="center">
      <Box component="img" src={bgIm} alt="Wind Turbine" sx={{ objectFit: "cover" }} />
    </MDBox>
  );
}
